import React, { useEffect, useState } from "react";
import { createInternship, updateInternship, getInternship } from "./api";
import styles from "./Form.module.css";

export default function InternshipsAdd() {
  const [form, setForm] = useState({
    title: "",
    description: "",
    qualification: "",
    year_of_passing: "",
    contact_email: "",
    office_location: "",
    last_date: "",
  });
  const [logo, setLogo] = useState(null);
  const [status, setStatus] = useState("");
  const [editId, setEditId] = useState(null);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const id = params.get('id');
    if (id) {
      setEditId(id);
      getInternship(id).then((res)=>{
        if (res.item) {
          setForm({
            title: res.item.title || "",
            description: res.item.description || "",
            qualification: res.item.qualification || "",
            year_of_passing: res.item.year_of_passing || "",
            contact_email: res.item.contact_email || "",
            office_location: res.item.office_location || "",
            last_date: res.item.last_date || "",
          });
        }
      }).catch(()=>{});
    }
  }, []);

  function updateField(e) {
    setForm({ ...form, [e.target.name]: e.target.value });
  }

  async function onSubmit(e) {
    e.preventDefault();
    setStatus("");
    const fd = new FormData();
    Object.entries(form).forEach(([k, v]) => fd.append(k, v));
    if (logo) fd.append("logo", logo);
    try {
      if (editId) {
        await updateInternship(editId, fd);
        setStatus("Updated");
      } else {
        await createInternship(fd);
        setStatus("Saved");
      }
      setForm({
        title: "",
        description: "",
        qualification: "",
        year_of_passing: "",
        contact_email: "",
        office_location: "",
        last_date: "",
      });
      setLogo(null);
    } catch (err) {
      setStatus(err.message || "Failed");
    }
  }

  return (
    <div className={styles.card}>
      <h2 className={styles.title}>Add Internship</h2>
      {status && <p>{status}</p>}
      <form className={styles.grid} onSubmit={onSubmit}>
        <div className={styles.row}>
          <div className={styles.label}>Job Title</div>
          <input className={styles.input} name="title" placeholder="Enter Job Title" value={form.title} onChange={updateField} required />
        </div>
        <div className={styles.row}>
          <div className={styles.label}>Job Description</div>
          <textarea className={styles.textarea} name="description" placeholder="Write Your Job Description" value={form.description} onChange={updateField} required />
        </div>
        <div className={styles.row}>
          <div className={styles.label}>Education Qualification</div>
          <input className={styles.input} name="qualification" placeholder="Enter Education Qualification Required" value={form.qualification} onChange={updateField} required />
        </div>
        <div className={styles.row}>
          <div className={styles.label}>Year Of Experience</div>
          <input className={styles.input} name="year_of_passing" placeholder="Enter Experience Required" value={form.year_of_passing} onChange={updateField} required />
        </div>
        <div className={styles.row}>
          <div className={styles.label}>Contact Email</div>
          <input className={styles.input} type="email" name="contact_email" placeholder="Enter Contact Email ID" value={form.contact_email} onChange={updateField} required />
        </div>
        <div className={styles.row}>
          <div className={styles.label}>Office Location</div>
          <input className={styles.input} name="office_location" placeholder="Enter Office Location" value={form.office_location} onChange={updateField} required />
        </div>
        <div className={styles.row}>
          <div className={styles.label}>Last date of submitting the applications</div>
          <input className={styles.date} type="date" name="last_date" value={form.last_date} onChange={updateField} required />
        </div>
        <div className={styles.row}>
          <div className={styles.label}>Upload Logo (Optional)</div>
          <input className={styles.file} type="file" accept="image/*" onChange={(e) => setLogo(e.target.files?.[0] || null)} />
        </div>
        <div className={styles.actions}>
          <button className={styles.button} type="submit">Submit</button>
        </div>
      </form>
    </div>
  );
}


